<ng-container *ngIf="htmlVideoPath; else videoPathNotDefined">
    <video [src]="htmlVideoPath" autoplay [muted]="false" oncontextmenu="return false;" [loop]="false"
           (ended)="watched.emit()">
    </video>
</ng-container>

<ng-template #videoPathNotDefined>
    <p>Video Path Not Defined.</p>
</ng-template>
